"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _booking = require("../../actions/booking");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _Input = _interopRequireDefault(require("../Form/Input"));
var _constants = require("../constants");
var _hooks = require("../../helpers/hooks");
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CrewName = function CrewName(_ref) {
  var booking = _ref.booking,
    isEventInFuture = _ref.isEventInFuture;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useToggle = (0, _hooks.useToggle)(),
    _useToggle2 = (0, _slicedToArray2["default"])(_useToggle, 2),
    on = _useToggle2[0],
    toggle = _useToggle2[1];
  var _useForm = (0, _hooks.useForm)({
      crewName: booking.crewName
    }),
    formData = _useForm.formData,
    handleChange = _useForm.handleChange;
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    notification = _useState4[0],
    setNotification = _useState4[1];
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var crewName;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setSubmitting(true);
            setNotification(null);
            crewName = formData.crewName;
            _context.prev = 3;
            _context.next = 6;
            return dispatch((0, _booking.updateCrewName)(booking, crewName || null));
          case 6:
            setNotification({
              show: true,
              text: 'Updated',
              type: 'success'
            });
            setSubmitting(false);
            toggle();
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            setNotification({
              show: true,
              text: _context.t0.message,
              type: 'error'
            });
            setSubmitting(false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var isSuccess = (notification === null || notification === void 0 ? void 0 : notification.type) === 'success';
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-right-xs"
  }, "Crew name:"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-text-bold"
  }, booking.crewName || 'not set'), isEventInFuture && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-left-md",
    text: isSuccess ? notification.text : "Edit",
    icon: isSuccess ? 'checkmark' : "edit",
    iconFlip: isSuccess,
    buttonType: isSuccess ? _constants.BUTTON_TYPES.BARE_SUCCESS_NO_PADDING : _constants.BUTTON_TYPES.BARE_PRIMARY_NO_PADDING,
    buttonSize: _constants.BUTTON_SIZES.SMALL,
    onClick: toggle
  })))), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    toggle: toggle,
    on: on
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "margin-bottom-md text-md"
  }, "Edit crew name:"), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    id: "crewName",
    name: "crewName",
    type: "text",
    placeholder: "Enter crew name",
    labelHidden: true,
    noMargin: true,
    onChange: handleChange,
    value: formData.crewName
  }), (notification === null || notification === void 0 ? void 0 : notification.type) === 'error' && /*#__PURE__*/_react["default"].createElement(_Alert["default"], (0, _extends2["default"])({
    className: "margin-top-md"
  }, notification)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-gap-md margin-top-lg"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Close",
    onClick: toggle,
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY,
    fullWidth: true,
    disabled: submitting
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Save",
    onClick: handleSubmit,
    fullWidth: true,
    disabled: submitting
  })))));
};
CrewName.propTypes = {
  booking: _propTypes["default"].object.isRequired,
  updateCrewName: _propTypes["default"].func.isRequired,
  isEventInFuture: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = CrewName;